import { AriaTabPanel, VStack } from "@kazaar-platform/design-system";
import { DeliveryLabelBloc } from "./DeliveryLabelBloc";
import { DeliveryNoteBloc } from "./DeliveryNoteBloc";
import { DispatchFileBloc } from "./DispatchFileBloc";
import { type DocumentsTabProps } from "./DocumentsTab.types";
import { ExtraAttachmentsBloc } from "./ExtraAttachmentsBloc";
import { PurchaseOrderBloc } from "./PurchaseOrderBloc";
import { ValidatedQuoteBloc } from "./ValidatedQuoteBloc";

export const DocumentsTab = ({ orderItem }: DocumentsTabProps) => {
  if (!orderItem) {
    return null;
  }

  return (
    <AriaTabPanel id="documents" style={{ flex: 1 }}>
      <VStack gap="sp-xl">
        <DispatchFileBloc
          dispatchFiles={orderItem?.sandboxItem?.dispatchFiles}
        />
        <ExtraAttachmentsBloc orderItem={orderItem} />
        <DeliveryLabelBloc orderItem={orderItem} />
        <PurchaseOrderBloc orderItem={orderItem} />
        <ValidatedQuoteBloc orderItem={orderItem} />
        <DeliveryNoteBloc orderItem={orderItem} />
      </VStack>
    </AriaTabPanel>
  );
};
